import React from 'react';
import Icon from '@pushpay/icon';
import { clsx, createUseStyles } from '@pushpay/styles';
// Should look at lifting this to the Theme
const transitionDuration = '400ms';
const useStyles = createUseStyles({
  root: {
    transition: `transform ${transitionDuration}`
  },
  modePlus: {},
  modeMinus: {
    transform: 'rotate(90deg)'
  }
});
const horizontalRectStyle = {
  transition: `opacity ${transitionDuration}`
};

const PlusMinusIcon = props => {
  const {
    mode,
    classes: classesProp,
    className: classNameProp,
    ...rest
  } = props;
  const classes = useStyles(classesProp);
  const className = clsx(classes.root, {
    [classes.modePlus]: mode === 'plus',
    [classes.modeMinus]: mode === 'minus'
  }, classNameProp);
  return /*#__PURE__*/React.createElement(Icon, Object.assign({
    viewBox: "0 0 24 24",
    className: className
  }, rest), /*#__PURE__*/React.createElement("rect", {
    style: { ...horizontalRectStyle,
      ...(mode === 'minus' && {
        opacity: 0
      })
    },
    fill: "currentColor",
    x: 6,
    y: 11,
    width: 12,
    height: 2,
    rx: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 11,
    y: 6,
    width: 2,
    height: 12,
    rx: 0.4
  }));
};

export default PlusMinusIcon;